import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LandingPage from '../features/landing/LandingPage';
import { API_BASE, AUTH_AUDIENCE } from '../config/env';

export function RootRedirectHandler() {
    const { isAuthenticated, isLoading, error, getAccessTokenSilently } = useAuth0();
    const [landingPath, setLandingPath] = useState('/appointments');
    const [loadingProfile, setLoadingProfile] = useState(false);

    useEffect(() => {
        if (!isAuthenticated || isLoading) return;
        let active = true;
        setLoadingProfile(true);
        (async () => {
            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: { audience: AUTH_AUDIENCE },
                });
                const profileResponse = await fetch(`${API_BASE}/users/me`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (!profileResponse.ok) throw new Error('profile load failed');
                const payload = await profileResponse.json();
                const mustChangePassword = Boolean(payload?.mustChangePassword);
                const raw = String(payload?.defaultLandingPath || '').trim();
                let next = raw.startsWith('/') && raw !== '/dashboard' ? raw : '/appointments';

                if (mustChangePassword) {
                    next = '/settings/account?forcePasswordChange=1';
                }

                if (active) setLandingPath(next || '/appointments');
            } catch {
                if (active) setLandingPath('/appointments');
            } finally {
                if (active) setLoadingProfile(false);
            }
        })();
        return () => {
            active = false;
        };
    }, [getAccessTokenSilently, isAuthenticated, isLoading]);

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center h-screen gap-4">
                <div className="text-red-600 font-semibold">Authentication Error</div>
                <div className="text-gray-600">{error.message}</div>
            </div>
        );
    }

    if (isLoading || (isAuthenticated && loadingProfile)) {
        return <div className="flex items-center justify-center h-screen">Loading...</div>;
    }

    if (isAuthenticated) {
        return <Navigate to={landingPath} replace />;
    }

    return <LandingPage />;
}
